import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useMedicalHistory = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["medicalHistory", patientId],
    queryFn: async () => {
      if (!patientId) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientmedicalhistory/getbypatientid/${patientId}`
      );
      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
  });
};
